/** PERMANENT SERVICE */
import { z } from "zod";
import { ShiftSchema } from "./Shift";
import { SiteSchema } from "./Site";
import { t } from "i18next";
import { positiveNumber, nonEmptyString, nonNegativeInteger, nonNegativeNumber, stringToNumber, postiveNumberZeroToOneHundred } from "@/utils/form";
import { RevenueCalculationSchema, ValidateRevenueCalculation } from "./RevenueCalculation";

export const ServiceSchema = z
  .object({
    additional: z.boolean().optional(),
    name: nonEmptyString(t("permanentservice.inputs.name.label")),
    operationalOrganizationId: z.preprocess(
      stringToNumber,
      z.number({
        error: (issue) => issue.input === undefined ?
          t("schemas:form.required")
          :
          t("schemas:form.invalid")
      })
    ),
    hourlyWage: positiveNumber(t("permanentservice.inputs.hourlywage.label")),
    hoursBriefingPerEmployee: nonNegativeInteger(
      t("permanentservice.inputs.hoursbriefingperemployee.label")
    ),
    transferredEmployeePercentage: postiveNumberZeroToOneHundred(
      t("permanentservice.inputs.transferredemployeepercentage.label")
    ),
    siteId: z.number().optional(),
    payGroup: z.string(),
    nonTariffAllowance: nonNegativeNumber(
      t("permanentservice.inputs.nontariffallowance.label")
    ),
    info: z.string().max(500, t("schemas:form.maxlength", { max: 500 })).optional(),
    shifts: z
      .array(ShiftSchema)
      .min(1, { message: t("schemas:permanentservice.shiftsrequired") }),
    pauseIncluded: z.boolean().default(true),
    siteInput: SiteSchema.optional(),
  })
  .extend(RevenueCalculationSchema.shape)
  .check((ctx) => {
    ValidateRevenueCalculation(ctx);
  });


export const ServiceDefaultValues = {
  additional: false,
  name: "",
  operationalOrganizationId: undefined,
  siteId: undefined,
  hourlyWage: undefined,
  nonTariffAllowance: 0,
  transferredEmployeePercentage: 0,
  info: "",
  revenueCalculationType: undefined,
  shifts: [],
  margin: 0,
  flatRate: undefined,
  hourlyRateAbsolute: undefined,
  hourlyRateRelative: undefined,
  pauseIncluded: true,
  siteInput: undefined,
  payGroup: "x"
};

export type TServiceSchema = z.infer<typeof ServiceSchema>;
